import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "app-container" }
const _hoisted_2 = { class: "left-card" }
const _hoisted_3 = { class: "top" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "avatar" }, null, -1)
const _hoisted_5 = { class: "headline" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, "Report for", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("h1", null, _toDisplayString(_ctx.name), 1)
        ])
      ]),
      _createElementVNode("nav", null, [
        _createVNode(_component_router_link, { to: "/" }, {
          default: _withCtx(() => [
            _createTextVNode("Daily")
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, { to: "/weekly" }, {
          default: _withCtx(() => [
            _createTextVNode("Weekly")
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, { to: "/monthly" }, {
          default: _withCtx(() => [
            _createTextVNode("Monthly")
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(_component_router_view)
  ]))
}